import { useEffect, useState } from "react";
import { useNavigate } from "react-router";

import AuthRoutes from "Routes/Components/Auth";

import UseAuth from "Hooks/UseAuth";

import Stepper from "./Components/Stepper";
import FirstForm from "./Forms/First";
import SecondForm from "./Forms/Second";
import * as S from "./styles";

const CreateProject = () => {
  const { authorized } = UseAuth();
  const navigate = useNavigate();

  const [projectId, setProjectId] = useState(null);
  const [step, setStep] = useState(0);
  const [projectData, setProjectData] = useState({});

  useEffect(() => {
    if (!authorized) {
      navigate(AuthRoutes.Dashboard.path);
    }
  }, [authorized]);

  const switchForm = (step) => {
    switch (step) {
      case 0:
        return (
          <FirstForm
            setStep={setStep}
            projectId={projectId}
            setProjectId={setProjectId}
            projectData={projectData}
            setProjectData={setProjectData}
          />
        );
      case 1:
        return (
          <SecondForm
            setStep={setStep}
            projectId={projectId}
            projectData={projectData}
            setProjectData={setProjectData}
          />
        );
      default:
        return (
          <FirstForm
            setStep={setStep}
            setProjectId={setProjectId}
            projectData={projectData}
            setProjectData={setProjectData}
          />
        );
    }
  };

  return (
    <S.Wrapper>
      <Stepper step={step} />

      {switchForm(step)}
    </S.Wrapper>
  );
};

export default CreateProject;
